export const AssignmentType = {
  PatientAssignment: 'PatientAssignment',
  LunchBreak: 'LunchBreak',
  NonPatientAssignment: 'NonPatientAssignment',
};
